import React, { forwardRef, Ref } from 'react';
import { InitialsField as InitialsFieldData } from '@dropbox/sign-internal-client';
import { ImperativeAPI } from '../types/imperative-api';
import { SignatureImage } from './signature-image';

type Props = {
  fieldData: InitialsFieldData;
  isFormView?: boolean;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};

function InitialsFieldInternal(
  {
    fieldData,
    isFormView,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: Props,
  ref: Ref<ImperativeAPI>,
) {
  if (fieldData.signature != null) {
    return (
      <SignatureImage
        isFormView={isFormView}
        signer={fieldData.signer}
        signatureGuid={fieldData.signature.guid}
        data-qa-ref={dataQaRef}
        data-testid={dataTestId}
        ref={ref}
      />
    );
  }

  return null;
}

export const InitialsField = forwardRef(InitialsFieldInternal);
